import * as React from 'react';
//import React, { useContext } from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HomeIcon from '@mui/icons-material/Home';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import FavoriteIcon from '@mui/icons-material/Favorite';
//import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function MenuBottAppBar({value}) {
  const navigate = useNavigate();

  return (
  <BottomNavigation
    showLabels
    value={value}
    onChange={(event, newValue) => {
      //setValue(newValue);
      navigate('/' + newValue);
    }}
  >
    <BottomNavigationAction label="Domů" value="Dashboard" icon={<HomeIcon />} />
    <BottomNavigationAction label="Energie" value="Energie" icon={<ElectricBoltIcon />} />
    <BottomNavigationAction label="Zdraví" value="Zdravi" icon={<FavoriteIcon />} />
  </BottomNavigation>
  )
}